<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ModeOfVerificationModal",
  props: {
    fromTemplate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      accessType: "",
      submitted: false,
      selectedTargetData: null,
      ratingData: [],
      movData: [],
      ratingLoading: false,
      movLoading: false,
      searchMOV: "",
      modalTitle: "",
      movCreateFields: [
        {
          key: "mode",
          label: "Mode",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          thStyle: { width: "90px" },
        },
      ],
      movViewFields: [
        {
          key: "mode",
          label: "Mode",
          sortable: true,
        },
      ],
      mov: {
        id: 0,
        planningTargetId: 0,
        mode: "",
        description: "",
      },
      alreadySaved: false,
    };
  },
  computed: {
    searchMode() {
      let data = this.movData;
      if (this.searchMOV.trim() != "" && this.searchMOV) {
        data = data.filter((item) => {
          return item.searchList
            .toUpperCase()
            .includes(this.searchMOV.toUpperCase());
        });
      }
      return data;
    },
  },
  validations: {
    mov: {
      mode: { required },
    },
  },
  methods: {
    setMeasurement(row, type) {
      this.ratingLoading = true;
      this.accessType = type;
      this.ratingData = [];
      this.selectedTargetData = cloneDeep(row);
      for (var count = 15; count > 0; count--) {
        this.ratingData.push({
          planningTargetId: row.id,
          planningTemplateMainTargetId: row.id,
          type:
            count > 10
              ? "EFFECTIVENESS/QUALITY"
              : count > 5 && count < 11
              ? "EFFICIENCY"
              : "TIMELINESS",
          rating:
            count > 10
              ? count - 10
              : count > 5 && count < 11
              ? count - 5
              : count,
          description: "",
        });
      }
      if (this.fromTemplate) {
        this.$store
          .dispatch(
            "planningtemplateratingscale/GetPlanningTemplateRatingScale",
            row.id
          )
          .then((res) => {
            if (res.data.length > 0) this.alreadySaved = true;
            for (
              var resultCounter = 0;
              resultCounter < res.data.length;
              resultCounter++
            ) {
              for (var ratingCounter = 0; ratingCounter < 15; ratingCounter++) {
                if (
                  res.data[resultCounter].rating ==
                    this.ratingData[ratingCounter].rating &&
                  res.data[resultCounter].type ==
                    this.ratingData[ratingCounter].type
                ) {
                  this.ratingData[ratingCounter] = res.data[resultCounter];
                }
              }
            }
            this.getMOV(row.id);
          })
          .catch(() => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        this.$store
          .dispatch("planningratingscale/GetPlanningRatingScale", row.id)
          .then((res) => {
            if (res.data.length > 0) this.alreadySaved = true;
            for (
              var resultCounter = 0;
              resultCounter < res.data.length;
              resultCounter++
            ) {
              for (var ratingCounter = 0; ratingCounter < 15; ratingCounter++) {
                if (
                  res.data[resultCounter].rating ==
                    this.ratingData[ratingCounter].rating &&
                  res.data[resultCounter].type ==
                    this.ratingData[ratingCounter].type
                ) {
                  this.ratingData[ratingCounter] = res.data[resultCounter];
                }
              }
            }
            this.getMOV(row.id);
          })
          .catch(() => {
            this.showToast("Something went wrong!", "error");
          });
      }
      this.ratingLoading = false;
    },
    async saveEvaluation() {
      if (this.movData.length == 0) {
        Swal.fire({
          title: "Cannot save.",
          text: "Add mode of verification to continue.",
          icon: "error",
          confirmButtonColor: "#7367f0",
          confirmButtonText: "Close",
        });
        return;
      }
      var deleteData = [];
      var updateData = [];
      var saveData = [];
      for (var counter = 0; counter < 15; counter++) {
        if (this.ratingData[counter].description.trim() != "") {
          if (this.ratingData[counter].id)
            updateData.push(this.ratingData[counter]);
          else saveData.push(this.ratingData[counter]);
        } else if (this.ratingData[counter].id) {
          deleteData.push(this.ratingData[counter]);
        }
      }
      for (
        var deleteCounter = 0;
        deleteCounter < deleteData.length;
        deleteCounter++
      ) {
        await this.$store.dispatch(
          "planningratingscale/DeletePlanningRatingScale",
          deleteData[deleteCounter].id
        );
      }
      if (updateData.length == 0 && saveData.length == 0) {
        this.showToast("There is no data to save.", "warning");
        return;
      }
      var error = 0;
      if (updateData.length > 0) {
        await this.$store
          .dispatch("planningratingscale/UpdatePlanningRatingScale", updateData)
          .then((res) => {
            if (res.data.error) {
              error = 2;
              return this.showToast(res.data.errorMessage, "error");
            }
          })
          .catch((err) => {
            error = 1;
          });
      }
      if (saveData.length > 0) {
        await this.$store
          .dispatch("planningratingscale/AddPlanningRatingScale", saveData)
          .then((res) => {
            if (res.data.error) {
              error = 2;
              return this.showToast(res.data.errorMessage, "error");
            }
          })
          .catch((err) => {
            error = 1;
          });
      }
      if (error == 0) {
        this.$bvModal.hide("performance-rating-modal");
        this.alreadySaved = true;
        await this.showToast("Successfully saved!", "success");
      } else if (error == 1) {
        await this.showToast("Something went wrong!", "error");
      }
    },
    async getMOV(id) {
      this.planningTargetId = id;
      this.movLoading = true;
      this.movData = [];
      if (this.fromTemplate) {
        await this.$store
          .dispatch("planningtemplatemov/GetTemplateMOVByTarget", id)
          .then(async (res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            for await (const item of res.data) {
              item.searchList = item.mode + " " + item.description;
              item.attachments = [];
              item.addDocu = false;
              item.attachmentLoading = false;
              item.viewFile = false;
              this.movData.push(item);
            }
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        await this.$store
          .dispatch("planningmov/GetMOVByTarget", this.planningTargetId)
          .then(async (res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            for await (const item of res.data) {
              item.searchList = item.mode + " " + item.description;
              item.attachments = [];
              item.addDocu = false;
              item.attachmentLoading = false;
              item.viewFile = false;
              this.movData.push(item);
            }
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
      this.movLoading = false;
    },
    onResetMOV() {
      this.submitted = false;
      this.mov = {
        id: 0,
        planningTargetId: this.planningTargetId,
        mode: "",
        description: "",
      };
      this.$v.mov.$reset();
    },
    updateMode(row) {
      this.onResetMOV();
      this.mov = cloneDeep(row);
      this.modalTitle = "Update Mode of Verification";
      this.$bvModal.show("mov-modal");
    },
    addMode() {
      this.onResetMOV();
      this.modalTitle = "Add Mode of Verification";
      this.$bvModal.show("mov-modal");
    },
    onSubmitMOV() {
      this.submitted = true;
      this.$v.mov.$touch();
      if (this.$v.mov.$invalid) {
        return;
      }
      if (this.mov.id > 0) {
        if (this.fromTemplate) {
          this.mov.planningTemplateMainTargetId = this.planningTargetId;
          this.$store
            .dispatch("planningtemplatemov/UpdateTemplateMOV", this.mov)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.movData.findIndex(
                (item) => item.id == this.mov.id
              );
              this.movData.splice(index, 1, this.mov);
              this.showToast("Successfully updated!", "success");
              this.$bvModal.hide("mov-modal");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        } else {
          this.$store
            .dispatch("planningmov/UpdateMOV", this.mov)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.movData.findIndex(
                (item) => item.id == this.mov.id
              );
              this.movData.splice(index, 1, this.mov);
              this.showToast("Successfully updated!", "success");
              this.$bvModal.hide("mov-modal");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      } else {
        if (this.fromTemplate) {
          this.mov.planningTemplateMainTargetId = this.planningTargetId;
          this.$store
            .dispatch("planningtemplatemov/CreateTemplateMOV", this.mov)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.showToast("Successfully saved!", "success");
              res.data.attachments = [];
              res.data.searchList = res.data.mode + " " + res.data.description;
              res.data.addDocu = false;
              res.data.attachmentLoading = false;
              res.data.viewFile = false;
              this.movData.push(res.data);
              this.$bvModal.hide("mov-modal");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        } else {
          this.$store
            .dispatch("planningmov/CreateMOV", this.mov)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.showToast("Successfully saved!", "success");
              res.data.attachments = [];
              res.data.searchList = res.data.mode + " " + res.data.description;
              res.data.addDocu = false;
              res.data.attachmentLoading = false;
              res.data.viewFile = false;
              this.movData.push(res.data);
              this.$bvModal.hide("mov-modal");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      }
    },
    deleteMode(row) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result) {
          if (this.fromTemplate) {
            this.$store
              .dispatch("planningtemplatemov/DeleteTemplateMOV", row.id)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                let index = this.movData.findIndex((item) => item.id == row.id);
                this.movData.splice(index, 1);
                this.showToast("Successfully deleted!", "success");
              })
              .catch((err) => {
                this.showToast("Something went wrong!", "error");
              });
          } else {
            this.$store
              .dispatch("planningmov/DeleteMOV", row.id)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                let index = this.movData.findIndex((item) => item.id == row.id);
                this.movData.splice(index, 1);
                this.showToast("Successfully deleted!", "success");
              })
              .catch((err) => {
                this.showToast("Something went wrong!", "error");
              });
          }
        }
      });
    },
    uploadMOVDocument(response, id) {
      var index = this.movData.findIndex((x) => x.id == id);
      this.movData[index].attachments.push(response);
    },
    openMOVDocument(x) {
      this.readFile(x.id);
    },
    uploadedMOVFiles() {},
    async getMOVAttachments(row) {
      row.viewFile = true;
      row.attachments = [];
      row.attachmentLoading = true;
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: this.uploadOptions.type,
        })
        .then((res) => {
          res.data.forEach((item) => {
            row.attachments.push(item);
          });
        })
        .catch(() => {
          this.showToast("Something went wrong! - getting documents", "error");
        });
      row.attachmentLoading = false;
    },
    removeMOVFile(id, parentId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.movData.findIndex((item) => item.id == parentId);
              let yIndex = this.movData[index].attachments.findIndex(
                (item) => item.id == id
              );
              this.movData[index].attachments.splice(yIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    async saveRubric() {
      var deleteData = [];
      var updateData = [];
      var saveData = [];
      for (var counter = 0; counter < 15; counter++) {
        if (this.ratingData[counter].description.trim() != "") {
          if (this.ratingData[counter].id)
            updateData.push(this.ratingData[counter]);
          else saveData.push(this.ratingData[counter]);
        } else if (this.ratingData[counter].id) {
          deleteData.push(this.ratingData[counter]);
        }
      }
      for (
        var deleteCounter = 0;
        deleteCounter < deleteData.length;
        deleteCounter++
      ) {
        await this.$store.dispatch(
          "planningtemplateratingscale/DeletePlanningTemplateRatingScale",
          deleteData[deleteCounter].id
        );
      }
      if (updateData.length == 0 && saveData.length == 0) {
        this.showToast("There is no data to save.", "warning");
        return;
      }
      var error = 0;
      if (updateData.length > 0) {
        await this.$store
          .dispatch(
            "planningtemplateratingscale/UpdatePlanningTemplateRatingScale",
            updateData
          )
          .then((res) => {
            if (res.data.error) {
              error = 2;
              return this.showToast(res.data.errorMessage, "error");
            }
          })
          .catch((err) => {
            error = 1;
          });
      }
      if (saveData.length > 0) {
        await this.$store
          .dispatch(
            "planningtemplateratingscale/AddPlanningTemplateRatingScale",
            saveData
          )
          .then((res) => {
            if (res.data.error) {
              error = 2;
              return this.showToast(res.data.errorMessage, "error");
            }
          })
          .catch((err) => {
            error = 1;
          });
      }
      if (error == 0) {
        this.$bvModal.hide("performance-rating-modal");
        await this.showToast("Successfully saved!", "success");
      } else if (error == 1) {
        await this.showToast("Something went wrong!", "error");
      }
    },
  },
};
</script>

<template>
  <!-- v-if="selectedTargetData" -->
  <div>
    <b-modal
      id="performance-rating-modal"
      title="Performance Rubric"
      size="xl"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <div
        v-if="ratingLoading"
        class="d-flex justify-content-center align-items-center p-3"
      >
        <div class="preloader-component me-2">
          <div class="status">
            <div class="spinner-chase w-20px h-20px">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <strong>Loading...</strong>
      </div>
      <div v-else-if="selectedTargetData">
        <div>
          <div class="mb-3">
            <h5>
              <span class="text-warning">{{ selectedTargetData.remarks }}</span>
            </h5>
          </div>
          <hr />
          <div v-if="ratingData.length > 0" class="row">
            <div class="col border-end pt-2">
              <h4 class="text-center mb-3">Effectiveness / Quality</h4>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">5.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 5"
                  v-model="ratingData[0].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">4.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 4"
                  v-model="ratingData[1].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">3.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 3"
                  v-model="ratingData[2].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">2.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 2"
                  v-model="ratingData[3].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">1.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 1"
                  v-model="ratingData[4].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
            </div>
            <div class="col border-end pt-2">
              <h4 class="text-center mb-3">Efficiency</h4>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">5.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 5"
                  v-model="ratingData[5].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">4.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 4"
                  v-model="ratingData[6].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">3.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 3"
                  v-model="ratingData[7].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">2.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 2"
                  v-model="ratingData[8].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">1.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 1"
                  v-model="ratingData[9].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
            </div>
            <div class="col pt-2">
              <h4 class="text-center mb-3">Timeliness</h4>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">5.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 5"
                  v-model="ratingData[10].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">4.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 4"
                  v-model="ratingData[11].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">3.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 3"
                  v-model="ratingData[12].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">2.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 2"
                  v-model="ratingData[13].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
              <div class="d-flex mb-2">
                <div>
                  <div style="min-width: 30px">
                    <h3 class="mb-0 position-relative">1.</h3>
                  </div>
                </div>
                <textarea
                  rows="3"
                  autocomplete="off"
                  class="form-control resize-none"
                  placeholder="Input Measurement No. 1"
                  v-model="ratingData[14].description"
                  :disabled="accessType == 'planning'"
                >
                </textarea>
              </div>
            </div>
          </div>
        </div>
        <h5 class="mt-4">Mode of Verification</h5>
        <hr />
        <div class="mt-3">
          <div class="d-flex justify-content-between">
            <div>
              <input
                type="text"
                class="form-control"
                placeholder="Search Mode..."
                v-model="searchMOV"
              />
            </div>
            <div v-if="accessType == 'du'">
              <button type="button" class="btn btn-info" @click="addMode()">
                <i class="bx bx-plus"></i>Add New Mode
              </button>
            </div>
          </div>
          <div class="table-responsive mt-2">
            <b-table
              bordered
              striped
              :items="searchMode"
              :fields="accessType == 'du' ? movCreateFields : movViewFields"
              :busy="movLoading"
              show-empty
            >
              <template #empty="scope">
                <div class="text-center">
                  {{ scope.emptyText }}
                </div>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template #cell(mode)="data">
                {{ data.item.mode }}
              </template>
              <template #cell(attachments)="data">
                <div>
                  <b class="me-1">Attachments:</b>
                  <a
                    class="font-size-12"
                    href="javascript:void(0);"
                    @click="getMOVAttachments(data.item)"
                    :id="`viewFiles-${data.item.id}`"
                    >[Show attachments]</a
                  >
                  <b-popover
                    :target="`viewFiles-${data.item.id}`"
                    triggers="click"
                    placement="right"
                    :show.sync="data.item.viewFile"
                    custom-class="popover-supplier"
                  >
                    <template v-slot:title>
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <small>Attachments</small>
                        <span
                          class="bx bx-x font-size-14 cursor-pointer"
                          @click="data.item.viewFile = false"
                        ></span>
                      </div>
                    </template>
                    <table
                      class="table table-bordered"
                      v-if="
                        !data.item.attachmentLoading &&
                        data.item.attachments.length > 0
                      "
                    >
                      <thead>
                        <tr>
                          <th>File Description</th>
                          <th style="width: 30px"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="y in data.item.attachments" :key="y.id">
                          <td
                            @click="openMOVDocument(y)"
                            class="hoverable-link cursor-pointer"
                          >
                            <div>
                              {{ y.description }}
                            </div>
                            <small>{{
                              formatDateWithTime(new Date(y.dateTimeUploaded))
                            }}</small>
                          </td>
                          <td>
                            <i
                              v-if="
                                $store.state.decrypt.isAdmin() ||
                                y.applicationUserId == token.ApplicationUserId
                              "
                              @click="removeMOVFile(y.id, data.item.id)"
                              class="cursor-pointer bx bx-trash text-danger"
                            ></i>
                            <i v-else class="bx bx-trash text-muted"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div
                      class="text-center"
                      v-if="
                        !data.item.attachmentLoading &&
                        data.item.attachments.length == 0
                      "
                    >
                      No data found
                    </div>
                    <div v-if="data.item.attachmentLoading" class="text-center">
                      <b-spinner
                        variant="primary"
                        label="Loading..."
                      ></b-spinner>
                    </div>
                  </b-popover>
                </div>
                <div v-if="accessType == 'du'" class="mt-2">
                  <button
                    :id="`pending-document${data.item.id}`"
                    type="button"
                    class="btn btn-sm btn-outline-success"
                    @click="data.item.addDocu = true"
                  >
                    <i class="bx bx-plus"></i>Add Attachments
                  </button>
                  <upload-popover
                    :option="uploadOptions"
                    :sourceId="data.item.id"
                    @uploaded="uploadedMOVFiles"
                    :showPV="data.item.addDocu"
                    @closePopover="data.item.addDocu = false"
                    :dzId="`dropzone-pending${data.item.id}`"
                    :pvId="`pending-document${data.item.id}`"
                  ></upload-popover>
                </div>
              </template>
              <template #cell(actions)="row">
                <div class="float-end">
                  <b-dropdown
                    id="dropdown-dropleft"
                    right
                    variant="link"
                    toggle-class="text-decoration-none"
                    menu-class="dropdown-menu-end"
                    no-caret
                  >
                    <template #button-content>
                      <i class="fas fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item
                      @click="updateMode(row.item)"
                      variant="dark"
                      ><i class="bx bx-edit font-size-18 me-1"></i
                      >Edit</b-dropdown-item
                    >
                    <b-dropdown-item
                      @click="deleteMode(row.item)"
                      variant="danger"
                      ><i class="mdi mdi-trash-can font-size-18 me-1"></i
                      >Delete</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="my-2 float-end">
          <div>
            <button
              v-if="accessType == 'du' && !fromTemplate"
              class="btn btn-success ms-1"
              @click="saveEvaluation()"
            >
              <i class="bx bx-save"></i> {{ alreadySaved ? "Update" : "Save" }}
            </button>
            <button
              v-if="fromTemplate"
              class="btn btn-success ms-1"
              @click="saveRubric()"
            >
              <i class="bx bx-save"></i> {{ alreadySaved ? "Update" : "Save" }}
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="mov-modal"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <form @submit.prevent="onSubmitMOV">
        <div class="mb-3">
          <label class="form-label">Mode</label>
          <textarea
            rows="3"
            autocomplete="off"
            class="form-control"
            placeholder="Enter Mode..."
            v-model="mov.mode"
          >
          </textarea>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Save Changes</button>
          <button
            type="button"
            class="btn btn-link"
            @click="$bvModal.hide('mov-modal')"
          >
            Close
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>
